export default class StatGrid {
  constructor(elem, APP) {
    this.elem = elem;
    this.buttons = this.elem.querySelectorAll('.js-stat-btn');
    // this.hasPointer = !window.matchMedia("(pointer: none)").matches;
  }

  resetButtons() {
    this.buttons.forEach((button) => {
      button.classList.remove('active');
      if(button.dataset.type == 'video') {
        button.querySelector('video').pause();
      }
    })
  }

  init() {
    this.buttons.forEach((button, i) => {
      button.addEventListener('mouseover', () => {
        button.classList.add('active');
        if(button.dataset.type == 'video') {
          button.querySelector('video').play();
        }
      });

      button.addEventListener('mouseleave', () => {
        button.classList.remove('active');
        if(button.dataset.type == 'video') {
          button.querySelector('video').pause();
        }
      });

      button.addEventListener('click', () => {
        this.resetButtons();
        button.classList.add('active');
        if(button.dataset.type == 'video') {
          button.querySelector('video').play();
        }
      });
    })
  }
}
